var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCdeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25402_41391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9533 0H0V27.9533H27.9533V0Z",
    fill: "#003D4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2113 14.9485L1.97573 24.7952L1.78906 13.0508L26.0246 3.2041L26.2113 14.9485Z",
    fill: "#78CFDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25402_41391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdeLogo);
export default __webpack_public_path__ + "static/media/cde_logo.709e78417af14ad50cdb11bb72de66f9.svg";
export { ForwardRef as ReactComponent };